import { v4 as uuidv4 } from "uuid"
import RequestForMovementGridPluginSettings from './RequestForMovementGridPluginSettings'
import { RequestForMovementPluginView } from './RequestForMovementPluginView'

export const RequestForMovementTab = (): ITab => {
    return {
        id: uuidv4(),
        title: "Заявки на перемещение",
        view: {
            content: RequestForMovementGridPluginSettings ? <RequestForMovementPluginView gridId={uuidv4()} plugin={RequestForMovementGridPluginSettings} /> : <p> Справочник не настроен </p>,
        },
    };
};
export default RequestForMovementTab;
